<script>
  import Card from "../Card.svelte";
  import CardBody from "../CardBody.svelte";
  import ImageComponent from "$lib/contentTypes/ImageComponent.svelte";

  export let url = "";
  export let title;
  export let description = "";

  export let imageComponent;
  export let resizeParams;
  export let widthsAt = {};
  export let id;
  export let dimensions = {};

  // `w-full` prevents svg from auto scale, but is needed for other images to fill the container
  $: isSvg = imageComponent?.fields.imageAsset?.fields?.file?.url?.endsWith("svg");
</script>

<Card {url} class="group flex flex-col items-start " let:hasFocus>
  <CardBody
    {title}
    {description}
    {url}
    {id}
    bodyClass="w-full flex flex-col items-start gap-16 pt-24 group-hover:underline order-2"
    titleClass="flex-shrink-0 heading-card font-normal group-focus:!no-underline leading-6.5"
  />

  <!-- image -->
  {#if imageComponent}
    <ImageComponent
      containerClass="border border-transparent group-focus:border-black group-focus:shadow-card group-active:shadow-card w-full {hasFocus &&
        'border-black shadow-card'} "
      elementClass="{!isSvg ? 'w-full' : ''} aspect-square object-cover overflow-hidden"
      data={imageComponent}
      displayCaption={false}
      responsive
      {resizeParams}
      {...widthsAt}
      {dimensions}
    />
  {/if}
</Card>
